import React from "react";
import { observer } from "mobx-react";
import store from './Stores/SurveyStore'
import ibsStore from './Stores/IbsSurveyStore'
import sharedStore from './Stores/SharedStore'
import { getInputRenderingInfo, dismissWarning, showErrorCommentModal, errorExplanationOptions } from '../helpers'
import { SurveyTypeURL } from "../Enums/constants";
import {NavLink} from 'reactstrap';
import { Link } from 'react-router-dom';
import { checkIfAnalyst } from "../Services/IBS/IbsService";
import { getSurveyResponseValue } from "../Helpers/General/SurveyResponsesHelper";

const SurveyTitleArea = observer((props) => {
    var isPageWithAlerts = !(store.currentLandedPage === "submit" 
        || store.currentLandedPage === "home"
        || store.currentLandedPage === "unlock"
        || store.currentLandedPage === "results"
        || (store.currentLandedPage === "assets" && (getSurveyResponseValue("IsAvgAssetsGiv") == null || getSurveyResponseValue("IsAvgAssetsGiv") === "")));
    var pageWarnings = store.pageFloatingWarnings;
    var pageErrors = store.pageFloatingErrors;


    const errorMessages = () => {
        var floatingErrors = [];
        pageErrors.forEach(error => {
            var errorItem = '<br\>' + error.ErrorMessage;
            var inputRenderingInfo = getInputRenderingInfo(error.QuestionName);
            var addExplanationPart = errorExplanationOptions(error.QuestionName, inputRenderingInfo);
            if (typeof addExplanationPart !== undefined && addExplanationPart != null) {
                errorItem = errorItem.concat(" ")
                //errorItem = errorItem.concat(addExplanationPart);
            }
            floatingErrors.push(<div>
                <div dangerouslySetInnerHTML={{ __html: error.ErrorMessage }} />
                {(typeof addExplanationPart !== undefined && addExplanationPart != null) &&
                    <span>&emsp;</span>
                }
                {(typeof addExplanationPart !== undefined && addExplanationPart != null) &&
                    addExplanationPart
                }
            </div>
            );
            if (floatingErrors.length > 0 && (pageErrors.length - floatingErrors.length) > 0) {
                floatingErrors.push(<br />)
            }
        });
        return floatingErrors;
    }

    const waringMessages = () => {
        var floatingWarnings = [];
        /*console.log("Current Year", store.currentYear);
        console.log("Current Survey Year", ibsStore.currentSurvey.DataYear);
        console.log("Current Data Year", sharedStore.currentDataYear);*/

        pageWarnings.forEach(error => {
            var errorItem = '<br\>' + error.ErrorMessage;
            var inputRenderingInfo = getInputRenderingInfo(error.QuestionName);
            var addExplanationPart = null;
            if (typeof inputRenderingInfo !== 'undefined') {
                var addExplanationPart = errorExplanationOptions(error.QuestionName, inputRenderingInfo);
            }
            if (typeof addExplanationPart !== undefined && addExplanationPart != null) {
                errorItem = errorItem.concat(" ")
                //errorItem = errorItem.concat(addExplanationPart);
            }
            floatingWarnings.push(<div>
                <div dangerouslySetInnerHTML={{ __html: error.ErrorMessage }} />
                {(typeof addExplanationPart !== undefined && addExplanationPart != null) &&
                    <span>&emsp;</span>
                }
                {(typeof addExplanationPart !== undefined && addExplanationPart != null) &&
                    addExplanationPart
                }
            </div>
            );
        });
        if (floatingWarnings.length > 0 && (pageWarnings.length - floatingWarnings.length) > 0 ) {
            floatingWarnings.push(<br />)
        }
        return floatingWarnings;
    }
    //&& (sharedStore.currentDataYear == ibsStore.currentSurvey.DataYear)
    var surveyYear
    if (ibsStore.currentSurvey && (store.surveyTypeUrl === SurveyTypeURL.DB || store.surveyTypeUrl === SurveyTypeURL.DC)) {
        surveyYear = ibsStore.currentSurvey.DataYear
    } else if (store.currentSurvey) {
        surveyYear = store.currentSurvey.DataYear
    }


    // Formatting for the label and error message top padding
    let labelTextJSX;
    let alertTopPadding;

    // If the label exists add it to the page
    if (props.labelText) {
        labelTextJSX = <React.Fragment><br /><h1 className="pageTitle">{props.labelText}</h1><br /></React.Fragment>;
    }
    // Padding is not needed if a label exists or there is no error message
    else if (store.cellErrorCount > 0 || store.cellWarningCount > 0 || waringMessages().length > 0 || errorMessages().length > 0) {
        alertTopPadding = <React.Fragment><br /></React.Fragment>;
    }


    return (
        <div style={{ paddingBottom: "15px" }}>
            {labelTextJSX}
            {(!store?.isPabsSurvey) && (!store.userCanEditReadOnlySurvey) && !ibsStore.currentSurvey?.IsLocked && (store.currentLandedPage != "home" && store.currentLandedPage != "results" && store.currentLandedPage != "unlock" && store.currentLandedPage != "laundromat" && store.currentLandedPage != "submit") &&
                <React.Fragment>
                    <br/>
                    <div class="alert alert-primary unlockMessage fade-in" role="alert">
                    Your survey has been submitted. To make changes, you must first <strong> < NavLink tag={Link} className="link-inline" to={store.surveyTypeUrl + "Unlock"}>unlock your survey.</NavLink> </strong>
                    </div>
                </React.Fragment>
            }
            {(!store?.isPabsSurvey) &&(ibsStore.currentSurvey?.IsLocked == 1 || ibsStore.currentSurvey?.SurveyStatusID == 1) && !checkIfAnalyst() && (store.currentLandedPage != "home" && store.currentLandedPage != "results" && store.currentLandedPage != "unlock" && store.currentLandedPage != "laundromat" && store.currentLandedPage != "submit") && 
                <React.Fragment>
                    <br />
                    <div class="alert alert-primary unlockMessage fade-in" role="alert">
                        Your survey is locked. Please contact CEM to unlock the survey and make changes.
                    </div>
                </React.Fragment>
            }
            {alertTopPadding}
            {/*isPageWithAlerts && (store.pageErrorCount > 0 || store.pageWarningCount > 0) && (sharedStore.currentDataYear == surveyYear)  &&
                <div className={store.errorBlockStyle} >
                    {errorMessages()}
                    {waringMessages()}
                    {store.cellErrorCount > 0 &&
                        <div>
                            This tab has <b> {store.cellErrorCount} critical errors </b>  highlighted in pink below that must be fixed before you can submit your data.
                        </div>}
                    {store.cellWarningCount > 0 &&
                        <div>
                            This tab has <b> {store.cellWarningCount} unusual data items/errors</b> highlighted in yellow below that you should check. Point the cursor at each highlighted field to see specific error messages.
                        </div>}
                   
                </div>
            */}
            {isPageWithAlerts && (store.pageErrorCount > 0 || store?.pageFloatingErrors?.length > 0) && 
                <div className={"alert alert-danger alert-dismissible fade-in"} >
                    {errorMessages()}
                    {store.cellErrorCount > 0 &&
                        <div>
                            This tab has <b> {store.cellErrorCount} critical errors </b>  highlighted in pink below that must be fixed before you can submit your data.
                        </div>}
                </div>
            }                    
            
            {store.pageWarningCount > 0 && store.pageErrorCount > 0 && <br />}
            {isPageWithAlerts && (store.pageWarningCount > 0 || store?.pageFloatingWarnings?.length > 0) &&
                <div className={store.errorBlockStyle} >
                    {waringMessages()}
                    {store.cellWarningCount > 0 &&
                        <div>
                            This tab has <b> {store.cellWarningCount} unusual data items/errors</b> highlighted in yellow below that you should check. Point the cursor at each highlighted field to see specific error messages.
                        </div>}

                </div>
            }
         
         

        </div>
    );
});
export default SurveyTitleArea;

